import { Component, Input } from '@angular/core';
import { IndicatorDetailComponent } from '../../organisms/indicator-detail/indicator-detail.component';
import { NgIf } from '@angular/common';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { Indicator } from '../../../models/indicator';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-indicator-detail-button',
  standalone: true,
  imports: [IndicatorDetailComponent, NgIf, OverlayPanelModule, ButtonModule],
  templateUrl: './indicator-detail-button.component.html',
  styleUrl: './indicator-detail-button.component.scss',
})
export class IndicatorDetailButtonComponent {
  @Input() indicator!: Indicator;
}
